import { UserAccountInfo } from "../getUserAccountInfo/UserAccountInfo";
export var getIsLoggedIn = function getIsLoggedIn() {
  return !!UserAccountInfo.getInstance().getData().accountNumber;
};